(function () {
  // Logic to remove cart items when a bundle is removed from the cart
  window.HS_SLIDE_CART_REMOVED_FROM_CART = async function ({ id }) {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    const updates = {};

    // get one of the items in the bundle
    const item = cart.items.find((item) => item.properties?._included_in == id);
    // get the includes
    if (item?.properties?._includes) {
      const includes = item.properties._includes.split(",");

      includes.forEach((include) => {
        const product = cart.items.find((item) => include == item.id);
        if (product) {
          updates[product.id] = Math.max(product.quantity - 1, 0);
        }
      });

      await updateCart(updates);
    }
  };

  window.HS_SLIDE_CART_UPDATED = async function (cart) {
    const updates = {};

    // check if includes without a bundle exists in the cart
    // if they do, remove them
    const includes = cart.items.filter(
      (item) => item.properties && item.properties._included_in,
    );
    includes.forEach((include) => {
      const bundle = cart.items.filter(
        (item) => item.id == include.properties._included_in,
      );
      if (bundle.length == 0) {
        updates[include.id] = 0;
      }
    });

    if (Object.keys(updates).length > 0) {
      await updateCart(updates);
    }

    updateCartItemItemsContent(cart);
    updateCartRewards(cart);
  };

  window.HS_SLIDE_CART_LOADED = function (cart) {
    updateCartItemItemsContent(cart);
    updateCartRewards(cart);
  };
})();

// This is the markup for the custom rewards-based component.
{
  /* <div
  class="hs-content-discounts-calculate-checkout hs-enable-content-rewards"
  id="hs-custom-rewards-based-discount"
>
  <div
    class="hs-rewards-content"
    data-key="hs-custom-rewards"
    data-discount-code="SecretSale"
    data-threshold="75"
    data-reward-message="Congrats! you have unlocked $25 off"
    data-progress-message="You’re only $[value] away from $25 off."
  >
    <div class="hs-progess-content">
      <div class="hs-content-text-rewards">
        <div class="hs-text-free-shipping">some</div>
      </div>
      <div class="hs-rewards-progress-bar-content hs-sl-goal-prices">
        <div class="hs-shipping-progress-bar">
          <div
            id="hs_shipping_bar"
            style="width:0%;"
            aria-labelledby="hs-progress-bar-lbl"
            tabindex="0"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow="0"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>; */
}

async function updateCartRewards(cart) {
  window.__hsRewardsLastCart = cart;
  let rewardsContainer =
    document.querySelector(".hs-custom-rewards") ||
    document.querySelector('[data-key="hs-custom-rewards"]');

  if (!rewardsContainer) {
    startRewardsContainerWatcher();
    return;
  }

  const discountApplied = document.querySelector("[data-discount-code]") ? checkIfDiscountApplied(
    cart,
    document.querySelector("[data-discount-code]").dataset.discountCode,
  ) : 0;
  const discountRewardsBar = document.getElementById(
    "hs-custom-rewards-based-discount",
  );

  let data = getShippingRewardsData(
    cart,
    Number(rewardsContainer.dataset.threshold),
    rewardsContainer.dataset.rewardMessage,
    rewardsContainer.dataset.progressMessage,
  );

  if (discountRewardsBar) {
    if (discountApplied) {
      rewardsContainer =
        discountRewardsBar.querySelector(".hs-custom-rewards") ||
        discountRewardsBar.querySelector('[data-key="hs-custom-rewards"]');
      if (!rewardsContainer) return;
      document.querySelectorAll(".hs-enable-content-rewards").forEach((el) => {
        el.style.display = "none";
      });
      discountRewardsBar.style.display = "block";

      data = getDiscountRewardsData(
        cart,
        Number(rewardsContainer.dataset.threshold),
        rewardsContainer.dataset.rewardMessage,
        rewardsContainer.dataset.progressMessage,
      );
      console.log("getDiscountRewardsData data:", data);
    } else {
      document.querySelectorAll(".hs-enable-content-rewards").forEach((el) => {
        el.style.display = "block";
      });
      discountRewardsBar.style.display = "none";
    }
  }

  const textElement = rewardsContainer.querySelector(".hs-text-free-shipping");
  if (textElement) {
    textElement.innerHTML = data.message;
  }

  const progressBar =
    rewardsContainer.querySelector("#hs_progress_bar") ||
    rewardsContainer.querySelector("#hs_shipping_bar");
  if (progressBar) {
    const widthValue = `${data.normalizedProgress.toFixed(2)}%`;
    progressBar.style.setProperty("width", widthValue);
    progressBar.setAttribute("aria-labelledby", "hs-progress-bar-lbl");
    progressBar.setAttribute(
      "aria-valuenow",
      Math.round(data.normalizedProgress).toString(),
    );
  }
}

function getShippingRewardsData(
  cart,
  thresholdValue,
  rewardMessage,
  progressMessage,
) {
  return getRewardsData(
    cart,
    thresholdValue,
    rewardMessage,
    progressMessage,
    (item) =>
      item.selling_plan_allocation || item.selling_plan
        ? 0
        : Number(item.line_price) || 0,
    true,
  );
}

function getDiscountRewardsData(
  cart,
  thresholdValue,
  rewardMessage,
  progressMessage,
) {
  return getRewardsData(
    cart,
    thresholdValue,
    rewardMessage,
    progressMessage,
    (item) => Number(item.original_line_price) || 0,
  );
}

function getRewardsData(
  cart,
  thresholdValue,
  rewardMessage,
  progressMessage,
  getItemValue,
  completeForSellingPlan = false,
) {
  const items = cart?.items || [];
  const rewardThreshold = Number.isFinite(thresholdValue)
    ? Math.max(Math.round(thresholdValue * 100), 1)
    : 5000;
  const hasSellingPlanItem = items.some(
    (item) => item.selling_plan || item.selling_plan_allocation,
  );

  const subtotal = items.reduce((value, item) => value + getItemValue(item), 0);

  const remainingAmount = Math.max(rewardThreshold - subtotal, 0);
  const progressValue =
    rewardThreshold > 0
      ? Math.min(
          Math.max(
            ((rewardThreshold - remainingAmount) / rewardThreshold) * 100,
            0,
          ),
          100,
        )
      : 0;
  const formattedRemaining = (remainingAmount / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const rewardReached =
    remainingAmount === 0 || (completeForSellingPlan && hasSellingPlanItem);
  const message = rewardReached
    ? rewardMessage
    : progressMessage.replace(
        "[value]",
        `<strong>$${formattedRemaining}</strong>`,
      );

  const normalizedProgress = rewardReached
    ? 100
    : Number.isFinite(progressValue)
      ? progressValue
      : 0;

  return {
    message,
    normalizedProgress: normalizedProgress,
  };
}

function checkIfDiscountApplied(cart, discountCode) {
  const targetCode = String(discountCode || "")
    .trim()
    .toLowerCase();
  if (!targetCode) return false;

  return Boolean(
    cart?.discount_codes?.some(
      (discount) => discount.code?.trim().toLowerCase() === targetCode,
    ),
  );
}

function startRewardsContainerWatcher() {
  if (window.__hsRewardsContainerWatcherInterval) {
    return;
  }

  let attempts = 0;
  const maxAttempts = 30;

  window.__hsRewardsContainerWatcherInterval = setInterval(() => {
    attempts += 1;

    const rewardsContainer =
      document.querySelector(".hs-custom-rewards") ||
      document.querySelector('[data-key="hs-custom-rewards"]');

    if (rewardsContainer) {
      clearInterval(window.__hsRewardsContainerWatcherInterval);
      window.__hsRewardsContainerWatcherInterval = null;
      updateCartRewards(window.__hsRewardsLastCart || { items: [] });
      return;
    }

    if (attempts >= maxAttempts) {
      clearInterval(window.__hsRewardsContainerWatcherInterval);
      window.__hsRewardsContainerWatcherInterval = null;
    }
  }, 500);
}

let subscriptionQuantityObserver;

function renderSubscriptionCartQuantities() {
  document
    .querySelectorAll(".hs-sticky-cart .hs-item-cart-content[data-item-key]")
    .forEach((row) => {
      // Line keys distinguish subscriptions from one-time lines sharing a variant ID.
      const item = window.orderQuantityLimits.lineForRow(row);
      const controls = row.querySelector(".hs-cart-plus-minus");
      if (!controls) return;

      let quantity = row.querySelector(".slidecart__subscription-quantity");
      const readOnly = item && !window.orderQuantityLimits.lineLimit(item).editable;
      if (!readOnly) {
        // Restore only controls previously hidden by this feature.
        if (row.hasAttribute("data-subscription-quantity")) {
          row.removeAttribute("data-subscription-quantity");
          controls.hidden = false;
          quantity?.remove();
        }
        window.orderQuantityLimits.updateLine(row, item);
        return;
      }

      if (!row.hasAttribute("data-subscription-quantity")) {
        row.setAttribute("data-subscription-quantity", "");
      }
      // Retain app-owned controls for restoration, but remove them from keyboard navigation.
      if (!controls.hidden) controls.hidden = true;
      if (!quantity) {
        quantity = document.createElement("span");
        quantity.className = "slidecart__subscription-quantity";
        controls.after(quantity);
      }
      // Avoid redundant DOM writes that would retrigger the observer indefinitely.
      if (quantity.textContent !== String(item.quantity)) {
        quantity.textContent = String(item.quantity);
      }
    });
}

function updateSubscriptionCartQuantities(cart) {
  window.orderQuantityLimits.setCart(cart);
  renderSubscriptionCartQuantities();

  if (subscriptionQuantityObserver) return;
  // App load callbacks can precede rendering; also reapply after later cart redraws.
  subscriptionQuantityObserver = new MutationObserver((mutations) => {
    const cartChanged = mutations.some(
      (mutation) =>
        mutation.target.closest?.(".hs-sticky-cart") ||
        [...mutation.addedNodes].some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches(".hs-sticky-cart") ||
              node.querySelector(".hs-sticky-cart")),
        ),
    );
    if (cartChanged) renderSubscriptionCartQuantities();
  });
  // Observe the body because the app can replace or insert the entire cart container.
  subscriptionQuantityObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function updateCartItemItemsContent(cart) {
  updateSubscriptionCartQuantities(cart);
  const items = cart?.items || [];

  items.forEach(async (gift) => {
    const response = await fetch(`/products/${gift.handle}?view=metafields`);
    const data = await response.json();

    if (data.metafield == null) return;
    const gE = document.querySelector(`.hs-product-${gift.id}`);
    const titleElement = gE?.querySelector(
      ".hs-content-product-and-variant-title",
    );
    if (!titleElement) return;
    if (
      !titleElement.querySelector(".slidecart__item-prefix-content") &&
      data.metafield != null &&
      data.metafield["line_item_content_line_1"]
    ) {
      let prefixDiv = document.createElement("div");
      prefixDiv.classList.add("slidecart__item-prefix-content");
      prefixDiv.innerHTML = data.metafield["line_item_content_line_1"];
      titleElement.prepend(prefixDiv);
    }

    if (
      !titleElement.querySelector(".slidecart__item-suffix-content") &&
      data.metafield["line_item_content_line_2"]
    ) {
      let suffixDiv = document.createElement("div");
      suffixDiv.classList.add("slidecart__item-suffix-content");
      suffixDiv.innerHTML = data.metafield["line_item_content_line_2"];
      titleElement.append(suffixDiv);
    }
  });

  // filter out gifts and show variant selector
  const gifts = items.filter((item) => item.product_type == "Gift");
  gifts.forEach(async (gift) => {
    const response = await fetch(
      `/products/${gift.handle}?view=variants&variant=${gift.id}`,
    );
    const html = await response.text();
    const parser = new DOMParser();
    // Parse the text
    const doc = parser.parseFromString(html, "text/html");

    const gE = document.querySelector(`.hs-product-${gift.id}`);
    const titleElement = gE?.querySelector(
      ".hs-content-product-and-variant-title",
    );
    if (
      !titleElement ||
      titleElement.querySelector(".slidecart__item-variants")
    ) {
      return;
    }
    let div = document.createElement("div");
    div.classList.add("slidecart__item-variants");
    div.innerHTML = doc.querySelector("body").innerHTML;
    titleElement.append(div);
  });
}
